import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DescriptorCategoriaService } from "../../descriptor-categoria/service/descriptor-categoria.service";
import { DescriptorService } from "../../descriptor/service/descriptor.service";
import { EspecieService } from "../../especie/service/especie.service";
import { VarietyFilter } from "../model/variedad.model";
import { VariedadService } from "../service/variedad.service";

export interface DesCatList {
  descriptor_category_id: number;
  value: string;
}

export interface DescriptorSearch {
  descriptor_id?: number;
  descriptor_label?: string;
  descriptor_name: string;
  selection_list?: DesCatList[];
  selection_value?: number | string;
  // selection_value_id?: number;
}

export interface SubTitleContent {
  sub_title?: string;
  descriptor_search_list: DescriptorSearch[];
}
export interface FormTemplate {
  title: string;
  sub_title_content: SubTitleContent[];
}

@Component({
  selector: "app-variedad-search",
  templateUrl: "./variedad-search.component.html",
  styleUrls: ["./variedad-search.component.css"],
})
export class VariedadSearchComponent implements OnInit {
  constructor(
    private router: Router,
    private descriptorService: DescriptorService,
    private descriptorCategoryService: DescriptorCategoriaService,
    private variedadService: VariedadService,
    private especiesService: EspecieService
  ) { }
  speciesValue!: string | number;
  formTemplateList: FormTemplate[] = [
    {
      title: "Taxonomia",
      sub_title_content: [
        {
          descriptor_search_list: [
            { descriptor_name: "Ploidia", selection_list: [] },
          ],
        },
      ],
    },
    {
      title: "Abundancia",
      sub_title_content: [
        {
          descriptor_search_list: [
            { descriptor_name: "Abundancia", selection_list: [] },
            {
              descriptor_name: "Frecuencia total de cultivares (OCF)",
              selection_list: [],
            },
          ],
        },
      ],
    },
    {
      title: "Características morfológicas",
      sub_title_content: [
        {
          sub_title: "Características de la planta",
          descriptor_search_list: [
            { descriptor_name: "Habito de crecimiento", selection_list: [] },
          ],
        },

        {
          sub_title: "Características de la flor",
          descriptor_search_list: [
            {
              descriptor_name: "Color predominante de la flor",
              selection_list: [],
            },
            {
              descriptor_name: "Color secundario de la flor",
              selection_list: [],
            },
            { descriptor_name: "Forma de la corola", selection_list: [] },
          ],
        },

        {
          sub_title: "Caracateristicas del Tuberculo",
          descriptor_search_list: [
            {
              descriptor_name: "Color predominante de la piel del tubérculo",
              selection_list: [],
            },
            {
              descriptor_name: "Color secundario de la piel del tubérculo",
              selection_list: [],
            },
            {
              descriptor_name: "Distribucion color secundario de piel",
              selection_list: [],
            },
            { descriptor_name: "Forma del tubérculo", selection_list: [] },
            {
              descriptor_name: "Forma secundaria del tubérculo",
              selection_list: [],
            },
            {
              descriptor_name: "Color predominante de la pulpa del tubérculo",
              selection_list: [],
            },
            {
              descriptor_name: "Color secundario de la pulpa del tubérculo",
              selection_list: [],
            },
            { descriptor_name: "Profundidad de ojos", selection_list: [] },
          ],
        },
      ],
    },
    {
      title: "Caracteristicas agronomicas",
      sub_title_content: [
        {
          descriptor_search_list: [
            {
              descriptor_name: "Rendimiento de tubérculos kg por planta",
              selection_list: [],
            },
            { descriptor_name: "Resistencia a la Rancha", selection_list: [] },
            { descriptor_name: "Resistencia a la Helada", selection_list: [] },
          ],
        },
      ],
    },
  ];
  speciesList!: any[];
  ngOnInit(): void {
    const _varietyFilterList = this.variedadService.getFilters();

    const _varietyFilterList_species = _varietyFilterList.filter(
      (x) => x.type == "SPECIES"
    );
    const _varietyFilterList_descriptor = _varietyFilterList.filter(
      (x) => x.type == "DESCRIPTOR"
    );

    this.fnGetAllSpecies(_varietyFilterList_species);
    this.fnGetDescriptorSearchList(_varietyFilterList_descriptor);
  }

  fnGetAllSpecies(varietyFilter: VarietyFilter[]) {
    this.speciesList = [];
    this.speciesValue = varietyFilter.map((x) => x.filter_value)[0];
    this.especiesService.getAll().subscribe((_especie: any) => {
      _especie.data.map((_element: any) => {
        const _optionItem: {
          species_id: number;
          species_name: string;
        } = {
          species_id: _element.species_id,
          species_name: _element.species_name,
        };
        this.speciesList.push(_optionItem);
      });
    });
  }

  fnGetDescriptorSearchList(varietyFilter: VarietyFilter[]) {
    this.formTemplateList.map((_formTemplate) => {
      _formTemplate.sub_title_content.map((_subTitleContent) => {
        _subTitleContent.descriptor_search_list.map(
          (_descriptorSearch: DescriptorSearch) => {
            this.descriptorService
              .getSearch(_descriptorSearch.descriptor_name)
              .subscribe((_respSearch) => {
                _respSearch.data.map((element) => {
                  // listas
                  this.descriptorCategoryService
                    .getByDescriptor(element.descriptor_id)
                    .subscribe((_respGetByDescriptor) => {
                      _respGetByDescriptor.data.map((elements) => {
                        _descriptorSearch.selection_list?.push({
                          descriptor_category_id:
                            elements.descriptor_category_id,
                          value:
                            elements.value != elements.description
                              ? elements.value + " - " + elements.description
                              : elements.value,
                        });
                      });
                    });

                  //  descriptor
                  _descriptorSearch.descriptor_id = element.descriptor_id;
                  _descriptorSearch.descriptor_label = element.catalog_label
                    ? element.catalog_label
                    : element.descriptor_name;

                  const _selection_value = varietyFilter
                    .filter((x) => x.descriptor_id == element.descriptor_id)
                    .map((y) => y.filter_value)[0];

                  _descriptorSearch.selection_value = _selection_value;
                });
              });
          }
        );
      });
    });
  }

  fnCacelar() {
    // this.router.navigate(["/catalogo"]);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/catalogo"]).then(() => {
      })
    })
  }

  fnBuscar() {
    this.variedadService.clearFilters();

    if (this.speciesValue) {
      const _especies = {
        type: "SPECIES",
        filter_value: this.speciesValue,
      };
      this.variedadService.addFilter(_especies);
    }
    this.formTemplateList.map((_formTemplate) => {
      _formTemplate.sub_title_content.map((_subTitleContent) => {
        _subTitleContent.descriptor_search_list.map((_descriptorSearch) => {
          if (_descriptorSearch.selection_value) {
            const _filter = {
              type: "DESCRIPTOR",
              descriptor_id: _descriptorSearch.descriptor_id,
              filter_value: _descriptorSearch.selection_value,
            };
            this.variedadService.addFilter(_filter);
          }
        });
      });
    });
    // this.router.navigate(["/catalogo"]);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/catalogo"]).then(() => {
      })
    })
  }

  //  fnOpenDialog(bt: any, _width: number): void {
  //   //you can use bt._elementRef.nativeElement or document.getElementById('btn')
  //   //const element=document.getElementById('btn');
  //   const _element = bt._elementRef.nativeElement;
  //   const _rect = _element
  //     ? _element.getBoundingClientRect()
  //     : { top: 0, left: 0 };
  //   const _dialogRef = this.dialog.open(DialogFilterComponent, {
  //     width: _width + "px",
  //     data: {
  //       name: this.name,
  //       animal: this.animal,
  //       matBadgeVarietyFilters: this.matBadgeVarietyFilters,
  //     },
  //     position: {
  //       top: _rect.bottom + "px",
  //       left: _rect.right - _width + "px",
  //     },
  //   });
  //   _dialogRef.afterClosed().subscribe((_result) => {
  //     this.animal = _result;
  //   });
  // }

  // fnClearFilters() {
  //   this.variedadService.clearFilters();
  // }
}
